import type { ReviewPhotoFilterV2Assignment } from '@typings/experiments';
import type { State } from 'types/redux';
import { selectAssignment } from '.';

const reviewPhotoFilterSelector = (state: State) => {
	//Entrance criteria: User scrolls to reviews section on a listing page
	//Location: apps/marketplace-web/client/pages/Storefront/containers/reviews/components/reviews/Reviews.tsx
	return (selectAssignment(state, ['reviewPhotoFilterV2']) ??
		null) as ReviewPhotoFilterV2Assignment;
};

const isInReviewPhotoFilterExperiment = (state: State) => {
	const reviewPhotoFilterAssignment = reviewPhotoFilterSelector(state);
	return reviewPhotoFilterAssignment === 'reviews-w-image-filter';
};

export {
	reviewPhotoFilterSelector,
	/** @knipignore - incoming experiment, ignoring for now */
	isInReviewPhotoFilterExperiment,
};
